export const messageBanners = (
    state = { banners: [] },
    action
) => {
    switch (action.type) {
        default:
            return state;
    }
};
